/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chargers properties that can be used for sorting. Default value is 'chargerId'.
 *
 */
export var ChargerPropertiesForSorting;
(function (ChargerPropertiesForSorting) {
    ChargerPropertiesForSorting["CHARGER_ID"] = "chargerId";
    ChargerPropertiesForSorting["LAST_KNOWN_CHARGER_STATUS"] = "lastKnownChargerStatus";
})(ChargerPropertiesForSorting || (ChargerPropertiesForSorting = {}));
